import { render, staticRenderFns } from "./addmumber.vue?vue&type=template&id=7f129ac0&scoped=true&"
import script from "./addmumber.vue?vue&type=script&lang=js&"
export * from "./addmumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f129ac0",
  null
  
)

export default component.exports